import startCase from 'lodash/startCase';

export const firstLetterUppercase = (value: string): string => startCase(value.toLowerCase());
